// extracted by mini-css-extract-plugin
module.exports = {"container":"EditButton_container__1agxr","image":"EditButton_image__9pay3","text":"EditButton_text__39DyF"};